
import useVuelidate from '@vuelidate/core';


export function validMayuscula(name) {
  let validNamePattern = new RegExp("(?=.*?[A-ZÑ])");
  if (validNamePattern.test(name)) {
    return true;
  }
  return false;
}

export function validMinuscula(name) {
  let validNamePattern = new RegExp("(?=.*?[a-zñ])");
  if (validNamePattern.test(name)) {
    return true;
  }
  return false;
}

export function validDigito(name) {
  let validNamePattern = new RegExp("(?=.*?[0-9])");
  if (validNamePattern.test(name)) {
    return true;
  }
  return false;
}

export function validEspecial(name) {
  let validNamePattern = new RegExp("[#?!@$%&*-_+|°~]");
  if (validNamePattern.test(name)) {
    return true;
  }
  return false;
}

export function validLongitud(name) {
  let validNamePattern = new RegExp(".{8,}");
  if (validNamePattern.test(name)) {
    return true;
  }
  return false;
}

export function validVacio(name) {
  let validNamePattern = new RegExp(".{1,}");
  if (validNamePattern.test(name)) {
    return true;
  }
  return false;
}

export function checkPassword(name) {
  let validNamePattern = this.newPass.pass_nueva;
  if (validNamePattern == name) {
    return true;
  }
  return false;
}
export default {

  setup() {
    return { v$: useVuelidate() }
  },

  name: "newPass",
  data() {
    return {
      dialogDocs: false,
      src: null,
      titulo: '',
      loading: false,
      departamentos: [],
      municipios: [],
      newPass: {
        confirmPassword: "",
        pass_nueva: "",
      },
    };
  },

  validations: {
    newPass: {
      pass_nueva: {
        mayuscula_validation: {
          $validator: validMayuscula,
          $message: 'Debe incluir al menos una mayúscula'
        },
        minuscula_validation: {
          $validator: validMinuscula,
          $message: 'Debe incluir al menos una minúscula'
        },
        digito_validation: {
          $validator: validDigito,
          $message: 'Debe incluir al menos un digito'
        },
        especial_validation: {
          $validator: validEspecial,
          $message: 'Debe incluir al menos un caracter especial (%$&#@-_)'
        },
        longitud_validation: {
          $validator: validLongitud,
          $message: 'Contraseña de almenos 8 digítos'
        },
        vacio_validation: {
          $validator: validVacio,
          $message: 'La contraseña es requerida'
        },
      },
      confirmPassword: {
        vacio_validation: {
          $validator: validVacio,
          $message: 'La contraseña es requerida'
        },
        confimar_validation: {
          $validator: checkPassword,
          $message: 'Las contraseñas no coinciden'
        },
      },

    }

  },
  async created() {


  },
  methods: {
    clear() {
      this.newPass = {
        confirmPassword: "",
        password: "",
      }
    },
    async cambiarPass() {
      //console.log(this.v$.newPass.$touch());
      this.loading = true;
      // console.log(this.$route.params.encriptado);
      try {
        this.newPass.token = this.$route.params.encriptado;
        let r = await this.$store.state.services.usuarioService.confirmar_cambiar_password(this.newPass);
        // console.log(r);

        if (r.data.success) {
          this.$toast.success("Su contraseña ha sido actualizada con éxito")
          this.loading = false;
          this.$router.push("/")
        } else {
          this.$toast.error("Error en el cambio de la contraseña")
          this.loading = false;

        }
      } catch (error) {
        this.$toast.error("Error en el cambio de la contraseña")
        this.loading = false;
        console.log(error);
      }

    },
  },


};